import Vue from 'vue'
import {setAegis } from '@/api/project'
const vm = new Vue()

export function convertToChinaNum(num) {
    var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'];//可继续追加更高位转换值
    if (!num || isNaN(num)) {
        return "零";
    }
    var english = num.toString().split("")
    var result = "";
    for (var i = 0; i < english.length; i++) {
        var des_i = english.length - 1 - i;//倒序排列设值
        result = arr2[i] + result;
        var arr1_index = english[des_i];
        result = arr1[arr1_index] + result;
    }
    //将【零千、零百】换成【零】 【十零】换成【十】
    result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
    //合并中间多个零为一个零
    result = result.replace(/零+/g, '零');
    //将【零亿】换成【亿】【零万】换成【万】
    result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
    //将【亿万】换成【亿】
    result = result.replace(/亿万/g, '亿');
    //移除末尾的零
    result = result.replace(/零+$/, '')
    //将【零一十】换成【零十】
    //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
    //将【一十】换成【十】
    result = result.replace(/^一十/g, '十');
    return result;
}

export function getUrlParam(urlStr, urlKey) {
    const url = new URL(urlStr) // 字符串转换成url格式
    const paramsStr = url.search.slice(1) // 获取'?'后面的参数字符串
    const paramsArr = paramsStr.split('&') // 分割'&'字符 获得参数数组
    for (let i = 0; i < paramsArr.length; i++) {
        const tempArr = paramsArr[i].split('=')
        if (tempArr[0] === urlKey) {
            return tempArr[1]
        }
    }
}

async function setAegisFunc(params) {
    try {
        console.log('setAegisFunc  start...');
        const {code,message} = await setAegis(params)
        console.log('setAegisFunc  result:');
        
        if (code !== 200) {
             console.error(`埋点错误：${message}`);
        }
    } catch (error) {
        console.error(`埋点错误：${error}`);
    }
}

export async function aegis(params) {
    const userinfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    console.log('setAegisFunc  before', );
    
    await setAegisFunc({
        click_area:params.clickarea ?? '',
        click_type:params.clicktype ?? '',
    })
    console.log('setAegisFunc  end', );
    
    if (Object.keys(userinfo)?.length) {
        const integrated = {
            RoleName: userinfo?.nickname ?? '',
            vHeadUrl: userinfo?.avatar ?? '',
            State: userinfo?.muted ? 2 : 1,
            //   clickarea: 'awards',
            //   clicktype: type, // 视频播放1/开始创作2/开始使用梦工坊3/社区4/文档5/视频学堂6
            devtype: userinfo?.loginData?.authType ?? 0,
            devstate: userinfo?.loginData?.devStat ?? 0,
            adminid: userinfo?.admin_group_id,
            adminname: userinfo?.admin_group_name ?? '',
            regdate: userinfo?.register_time ?? 0,
            ...params
        }
        console.log('vm.$aegis', vm.$aegis);
        // Playerclick
        vm.$aegis.report({
            msg: 'Playerclick',
            ext1: String(params?.clicktype), // 视频播放1/开始创作2/开始使用梦工坊3/社区4/文档5/视频学堂6,播放视频 7
            ext2: userinfo?.muted ? '2' : '1', //账号状态
            ext3: JSON.stringify(integrated), //
            // trace: 'trace',
        })
        console.log('Playerclick');
        
    } else {
        // 游客
        // Playerclick
        vm.$aegis.report({
            msg: 'Playerclick',
            ext1: String(params?.clicktype), // 视频播放1/开始创作2/开始使用梦工坊3/社区4/文档5/视频学堂6
            ext2: '0', //点击区域
            //   ext3: 0, //账号状态 0 游客
        })
    }
}

 
export function getChatRequestRoot(envStatus) {
    const Ticket = {
        // 轻游戏开发者中心测试环境
        'minicreate.': 'https://wxup-hosting-test.game.qq.com',
        // 轻游戏开发者中心正式环境
        'qyx.': 'https://wxup-hosting-pub.game.qq.com',
        'dream.': 'https://wxup-hosting-pub.game.qq.com',
        // 外部传入环境
        '1': 'https://wxup-hosting-test.game.qq.com',
        '2': 'https://wxup-hosting-pre.game.qq.com',
        '3': 'https://wxup-hosting-eapre.game.qq.com',
        '4': 'https://wxup-hosting-ea.game.qq.com',
        '5': 'https://wxup-hosting-pub.game.qq.com',
    };
    if (envStatus) {
        return Ticket[envStatus];
    }
    const key = Object.keys(Ticket).find(key => location.host.startsWith(key))
    if (key) {
        return Ticket[key]
    }
}

export function getOtherTicketFlag() {
    const Ticket = {
        // 轻游戏开发者中心预发布环境
        'minicreate': 'minipre-Ticket',
        // 轻游戏开发者中心EA环境
        'qyx': 'qyxea-Ticket',
        'dream': 'qyxea-Ticket',
    };
    const key = Object.keys(Ticket).find(key => location.host.startsWith(key))
    if (key) {
        return Ticket[key]
    }
}

export function getTicketFlag() {
    const Ticket = {
        // 轻游戏开发者中心测试环境
        'minicreate': 'minitest-Ticket',
        // 轻游戏开发者中心正式环境
        'qyx': 'minicreate-Ticket',
        'dream': 'minicreate-Ticket',
    };
    const key = Object.keys(Ticket).find(key => location.host.startsWith(key))
    if (key) {
        console.log(Ticket[key]);
        return Ticket[key]
    }
}

export function getJumpLink() {
    const Ticket = {
        // 轻游戏开发者中心测试环境
        'minicreate': 'https://dev.minicreate.qq.com/#/',
        // 轻游戏开发者中心正式环境
        'qyx': 'https://dev.dream.qq.com/#/',
        'dream': 'https://dev.dream.qq.com/#/',
    };
    const key = Object.keys(Ticket).find(key => location.host.startsWith(key))
    if (key) {
        console.log(Ticket[key]);
        return Ticket[key]
    }
}

export function confirmCarryVerification() {
    /*
        该正则匹配规则表示: 首先匹配的格式是 xxx = xxx
                           然后[^?|&] 表示匹配的字符中不能含有 ? 或者 &，后面同理
    */
    let pattern = /([^?|&]+)=([^&]+)/ig;
    let url = location.href;
    let result = {};
    url.replace(pattern, ($, $1, $2) => {
        result[$1] = $2;
    })
    if (result.ticket) {
        return {
            ticket: result.ticket,
        }
    }
    if (result.token && result.redirect_url) {
        return {
            token: result.token,
            redirect_url: decodeURIComponent(result.redirect_url),
        }
    } else {
        return false
    }
}


/**
 * 社区 添加图片放大、a标签添加新开页跳转、视频添加播放按钮和隐藏下载
 * @param {*} params 
 */
export function handleRichtextEle(ele) {
    let imgArr=[]
    if(!ele){
        imgArr = document.querySelectorAll('.community_post_container img') ??[]
    }else{
        imgArr = ele?.querySelectorAll('img')?? [] 
    }
    const imgList = Array.from(imgArr).map(i => i?.src || '').filter(Boolean);
    for (let i = 0; i < imgArr.length; i++) {
        if(imgArr[i].alt==='emoji-image') continue
        imgArr[i].title = '图片可点击放大'
        imgArr[i].style.cursor = 'pointer'
        imgArr[i].addEventListener('click', () => {
            vm.$hevueImgPreview({
                multiple: true,
                nowImgIndex: i,
                imgList,
                clickMaskCLose: true,
            })
        })
    }

    // a标签添加新开页面跳转
    const links = document.querySelectorAll('.community_post_container a')
    links.forEach((item) => {
        if (!item.href.includes('#')) {
            item.target = '_blank'
        }
    })

    // 视频去除下载 和添加播放按钮
    const videoArr = document.getElementsByTagName('video');

    for (let i = 0; i < videoArr.length; i++) {
        // videoArr[i].setAttribute('controls', undefined)
        videoArr[i].setAttribute('controlsList', 'nodownload')
        videoArr[i].setAttribute('oncontextmenu', 'return false')
        videoArr[i].style.width = '100%'
        // videoArr[i].style.objectFit='cover'
        //  videoArr[i].style.display = 'none'
        const parent = videoArr[i].parentElement;
        parent.style.position = 'relative'
        const div = document.createElement('div');
        div.className = 'w-video-play-btn';
        div.innerHTML = `<svg width="65" height="65" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#333" stroke="#333" stroke-width="4" stroke-linejoin="round"/><path d="M20 24V17.0718L26 20.5359L32 24L26 27.4641L20 30.9282V24Z" fill="#FFF" stroke="#FFF" stroke-width="4" stroke-linejoin="round"/></svg>`

        div.addEventListener('click', () => {
            // div.style.display = 'none';
            videoArr[i].play();
            parent.classList.remove('hiddenPlay')
            parent.classList.add('openVideo','videoPlay')
        })

        parent.appendChild(div)

        videoArr[i].addEventListener('pause',()=>{
            // div.style.display = 'block';
            parent.classList.remove('videoPlay')
            parent.classList.add('hiddenPlay')
        })
        videoArr[i].addEventListener('play',()=>{
            parent.classList.remove('hiddenPlay')
            parent.classList.add('videoPlay')
        })
    }

}

export const isProd = () => {
    return location.host.startsWith('qyx.qq.com') || location.host.startsWith('dream.qq.com')
}


export const getDevMainpage = () => {
    // return 'dev.dream.qq.com'
    return 'dev.dream.qq.com'
}

export const getDevEAMainpage = () => {
    // return 'eadev.dream.qq.com'
    return 'eadev.dream.qq.com'
}

import { getToken } from '@/utils/auth'
export const needLogin = () => {
    // console.log(getToken(),'token~~~~~~~~~~~~~~');
    if (getToken()) {
        return false
    } else {
        if (!isMobile()) {
          window.location.href = `/#/oauth?app_id=5012568a421eeb0b&redirect_url=${location.href}`  
        }
        return true
    }
}

export const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

// 修改html字体大小
export const  handleHtmlFront = () => {
 function setHtmlFontSize() { 
    const html = document.documentElement;
    let designWidth = 2560; // todo
    if (isMobile()) {
       designWidth = 750;
       html.style.fontSize = html.clientWidth / designWidth * 100 + "px";
    }
  }
  setHtmlFontSize()
  window.addEventListener('resize', ()=>{
    let timer;
    clearTimeout(timer);
    timer = setTimeout(setHtmlFontSize, 300);
});
}

// 下载 
export const downloadFile=(url)=> {
  console.log("downloadFile start");
  
   const link = document.createElement("a");
   link.href = url;
   const fliename = url.split("/").pop();
   link.download = fliename;
   document.body.appendChild(link);
   console.log('before click');
   
   link.click();
   console.log('after click');
   
   document.body.removeChild(link); 
   console.log("downloadFile end");
 }

/**
 * 截断富文本内容
 * 
 * 该函数用于截断给定的富文本（HTML），使其字符数不超过指定限制
 * 它会尽量保留文本、图片和表情包等内容，直到达到字符限制为止
 * 
 * @param {string} html - 输入的富文本（HTML）字符串
 * @param {number} maxChars - 最大字符限制，包括文本、图片和表情包等所有内容
 * @param {boolean} needShowPic - 是否显示图片，如果为true，则图片会被保留（如果在字符限制内）
 * @param {boolean} needShowUrl - 是否显示链接，如果为true，则链接会被保留（如果在字符限制内）
 * @returns {object} - 返回一个对象，包含截断后的HTML内容、文本字符数、图片数、表情包数、总字符数和是否达到限制
 */
export function truncateRichText(html,maxChars,needShowPic,needShowUrl) {

    // console.log('html maxChars', maxChars)
    const tempDiv = document.createElement('span');
    tempDiv.innerHTML = html;

    let currentChars = 0;
    let textChars = 0;  // 文字个数
    let imageCount = 0; // 图片个数
    let emoji1Count = 0; // 表情包1
    let emoji2Count = 0; //  表情包2

    const resultDiv = document.createElement('span');
    let reachedLimit = false;

    function processNode(node) {
        if (reachedLimit) return;
        // console.log('node', node.className);

        // 处理文本节点
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            const remaining = maxChars - currentChars;

            if (text.length <= remaining) {
                // 整个文本节点都在限制内
                resultDiv.appendChild(document.createTextNode(text));
                currentChars += text.length;
                textChars += text.length;
            } else {
                // 只取部分文本
                resultDiv.appendChild(document.createTextNode(text.substring(0, remaining)));
                textChars += remaining;
                currentChars += remaining;
                reachedLimit = true;
            }
            return;
        }

        // 处理元素节点
        if (node.nodeType === Node.ELEMENT_NODE) {
            // 处理图片和表情包
            if (node.tagName === 'IMG'|| (node.tagName === 'A' && needShowUrl)) {
                let charValue = 0;
                let isEmoji = false;

                if (node.alt === 'emoji-image' || node.className.includes('emoji-img-show') || node.src.includes('https://game.gtimg.cn/images/datamore/cp/cc/emoj/DM_')) {
                    if ( node.src.includes('/malou')) {
                        charValue = 6;
                        emoji2Count++;
                    } else {
                        charValue = 2;
                        emoji1Count++;
                    }
                    isEmoji = true
                } else {
                    charValue = 50; // 回复的a标签也会走到这里来
                    imageCount++;
                }

                if (currentChars + charValue <= maxChars && (isEmoji || needShowPic || needShowUrl)) {
                    const clone = node.cloneNode(true);
                    if(isEmoji) clone.style.display = 'inline-block'; // 表情包变为内元素
                    resultDiv.appendChild(clone);
                    currentChars += charValue;
                    // console.log('html currentChars',currentChars);

                } else  {
                    reachedLimit = true;
                }
                return;
            }

            // 处理其他元素（递归处理子节点）
            // const clone = node.cloneNode(false); // 浅拷贝（不含子节点）
            // resultDiv.appendChild(clone);

            for (const child of node.childNodes) {
                processNode(child);
                if (reachedLimit) break;
            }

            return;
        }
    }
    // 处理除了文字、图片和表情包的内容  
    function handleOtherHtmlContent(node) { 
        if (reachedLimit) return;
         // 处理元素节点 
        if (node.nodeType === Node.ELEMENT_NODE){
            if (['TABLE','VIDEO','FORM','IFRAME'].includes(node.tagName)) { // 可以继续加需要处理的标签
                reachedLimit = true;
                return;
            }
        }
        for (const child of node.childNodes) {
             handleOtherHtmlContent(child);
             if (reachedLimit) break;
         }
         return;
     }

    // 处理所有子节点
    for (const child of tempDiv.childNodes) {
        processNode(child);
        if (reachedLimit) break;
    }
    // 另外判断一下是否需要收起 
    for (const child of tempDiv.childNodes) {
        handleOtherHtmlContent(child);
        if (reachedLimit) break;
    }

    const totalChars = currentChars;
    if (reachedLimit) {
        resultDiv.innerHTML += '...';
    }
    // console.log('totalChars', totalChars);

    return {
        content: resultDiv.innerHTML,
        textChars,
        imageCount,
        emoji1Count,
        emoji2Count,
        totalChars,
        reachedLimit
    };
}